import $script from './script';
import * as ajax from './ajax';

{

	let canvas = document.querySelector( '.stockists__map' );

	if( canvas ) {

		$script( 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAMHzScpArGw_gACd_SQRm__1iE-lk-6hE&callback=stockistsInit', null );

	}

	function windowWidth() {

		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	
	}

	window.stockistsInit = function() {

		let selectedMarker;

		let info = document.querySelector( '.stockist-info' );
		let infoName = document.querySelector( '.stockist-info__name' );
		let infoAddress = document.querySelector( '.stockist-info__address' );

		let latlng = {lat: 54.559322, lng: -4.174804};

		let zoom = ( windowWidth() > 600 ) ? 6 : 5;

		let map = new google.maps.Map( canvas, {
			center: latlng,
			zoom: zoom,
			scrollwheel: false,
			disableDefaultUI: true
		} );

		let image = {
			url: window.probalm.mapMarker,
			size: new google.maps.Size( 20, 37.505 ),
			scaledSize: new google.maps.Size( 20, 37.505 ),
			anchor: new google.maps.Point( 10, 37.505 )
		};

		let imageSelected = {
			url: window.probalm.mapMarkerInverse,
			size: new google.maps.Size( 20, 37.505 ),
			scaledSize: new google.maps.Size( 20, 37.505 ),
			anchor: new google.maps.Point( 10, 37.505 )
		};

		function markerClick() {

			infoName.innerHTML = this.infoName;
			infoAddress.innerHTML = this.infoAddress;
			info.classList.add( 'stockist-info--active' );

			if( selectedMarker ) {
				selectedMarker.setIcon( image );
			}

			this.setIcon( imageSelected );

			selectedMarker = this;

		}

		document.querySelector( '.stockist-info__close' ).addEventListener( 'click', function() {

			info.classList.remove( 'stockist-info--active' );

			if( selectedMarker ) {
				selectedMarker.setIcon( image );
			}

		} );


		document.querySelector( '.stockists__zoom--in' ).addEventListener( 'click', function() {

			map.setZoom( map.getZoom() + 1 );

		} );

		document.querySelector( '.stockists__zoom--out' ).addEventListener( 'click', function() {

			map.setZoom( map.getZoom() - 1 );

		} );


		ajax.post( window.probalm.ajaxUrl, {action: 'probalm_stockists'}, function( res ) {

			let data = JSON.parse( res );

			for( let i = 0; i < data.length; i++ ) {

				let latlng = data[i].latlng.split( ',' );
				let lat = parseFloat( latlng[0] );
				let lng = parseFloat( latlng[1] );

				let marker = new google.maps.Marker( {
					position: {lat: lat, lng: lng},
					map: map,
					icon: image,
					infoName: data[i].name,
					infoAddress: data[i].address
				} );

				marker.addListener( 'click', markerClick );

			}

		} );

	};

}



/** WEBPACK FOOTER **
 ** stockists.js
 **/